if (!window.faqScriptLoaded) {
  window.faqScriptLoaded = true;

  document.addEventListener("DOMContentLoaded", () => {
    const faqItems = document.querySelectorAll(".faq-main-wrap .faq-item");

    if (!faqItems.length) return;

    // Open first FAQ
    const firstItem = faqItems[0];
    const firstQuestion = firstItem.querySelector(".faq-question");
    const firstAnswer = firstItem.querySelector(".faq-answer");

    if (firstQuestion && firstAnswer) {
      firstItem.classList.add("open");
      firstQuestion.classList.add("active");

      firstAnswer.style.height = "0px";
      firstAnswer.style.paddingTop = "30px";
      firstAnswer.style.paddingBottom = "30px";
      firstAnswer.offsetHeight;

      firstAnswer.style.height = firstAnswer.scrollHeight + "px";

      firstAnswer.addEventListener(
        "transitionend",
        function handler() {
          if (firstItem.classList.contains("open")) {
            firstAnswer.style.height = "auto";
          }
          firstAnswer.removeEventListener("transitionend", handler);
        }
      );
    }

    faqItems.forEach((item) => {
      const question = item.querySelector(".faq-question");
      const answer = item.querySelector(".faq-answer");

      if (!question || !answer) return;

      question.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");

        // Close all FAQs
        faqItems.forEach((i) => {
          const q = i.querySelector(".faq-question");
          const a = i.querySelector(".faq-answer");

          if (!q || !a) return;

          i.classList.remove("open");
          q.classList.remove("active");

          // If height is auto, set fixed height first
          a.style.height = a.scrollHeight + "px";
          a.offsetHeight;

          a.style.height = "0px";
          a.style.paddingTop = "0";
          a.style.paddingBottom = "0";
        });

        // Open clicked FAQ
        if (!isOpen) {
          item.classList.add("open");
          question.classList.add("active");

          answer.style.height = "0px";
          answer.style.paddingTop = "30px";
          answer.style.paddingBottom = "30px";
          answer.offsetHeight;

          answer.style.height = answer.scrollHeight + "px";

          answer.addEventListener(
            "transitionend",
            function handler() {
              if (item.classList.contains("open")) {
                answer.style.height = "auto";
              }
              answer.removeEventListener("transitionend", handler);
            }
          );
        }
      });
    });
  });
}